import { Breakpoints } from '../breakpoints/breakpoints';
import { DragBar } from '../drag-bar/drag-bar';
import moduleRegistry from '../module-registry/module-registry';

const config = {
    selectors: {
        root: '.card-tiles',
        tiles: '.card-tiles__tiles',
        tile: '.card-tiles__tile',
        bar: '.card-tiles__bar',
    },
    dataAttributes: {
    },
    classNames: {
        cardTilesTwo: 'card-tiles--two',
        cardTilesThree: 'card-tiles--three',
    },
    sliderConfig: {
        dots: false,
        infinite: false,
        speed: 300,
        slidesToShow: 1.1,
        slidesToScroll: 1,
        mobileFirst: true,
        autoplay: false,
        arrows: false,
    },
};

class CardTiles {
    constructor($rootElement) {
        this._$rootElement = $rootElement;
        this._elements = null;
        this._isSlider = false;
    }

    init() {
        if (!this._$rootElement.hasClass(config.classNames.cardTilesTwo)
            && !this._$rootElement.hasClass(config.classNames.cardTilesThree)) return;

        this._elements = this._getDomElements();
        this._addEventListeners();

        if (Breakpoints.isBreakpoint('xs')) {
            this._initSlider();
            this._initBar();
        }

    }

    _getDomElements() {
        return {
            $tiles: this._$rootElement.find(config.selectors.tiles),
            $tile: this._$rootElement.find(config.selectors.tile),
            $bar: this._$rootElement.find(config.selectors.bar),
        };
    }

    _addEventListeners() {
        const _this = this;

        this._elements.$tiles.on('beforeChange', (event, slick, currentSlide, nextSlide) => {
            const $bar = _this._elements.$bar.find(DragBar.getClassname());

            if(event.target !== _this._elements.$tiles[0]) return;
            
            DragBar.setIndex($bar, nextSlide);
        });

        Breakpoints.onBreakpointChange(() => {
            if (!this._isSlider && (Breakpoints.isBreakpoint('xs'))) {
                this._initSlider();
                this._initBar();
            } else if (this._isSlider && Breakpoints.isBreakpoint('sm')) {
                this._destroySlider();
            }
        });
    }

    _initSlider() {
        this._isSlider = true;
        this._elements.$tiles.slick(config.sliderConfig);
        // this._multiSlideAdaptiveHeight(this._elements.$tiles);
    }

    _destroySlider() {
        this._isSlider = false;
        this._elements.$tiles.slick('unslick');
    }

    _initBar() {
        // create bar and append into dom
        const barHtml = DragBar.createHtml(Math.ceil(this._elements.$tile.length));
        if(this._elements.$tile.length === 1) {
            this._elements.$bar.css('display', 'none')
        }

        this._elements.$bar.html(barHtml);

        // select bar and register callback
        const $bar = this._elements.$bar.find(DragBar.getClassname());

        DragBar.init($bar, (index) => {
            this._elements.$tiles.slick('slickGoTo', index);
        });
    }

    _multiSlideAdaptiveHeight(slider) {
        const _this = this;

        // set our vars
        let activeSlides = [];
        let tallestSlide = 0;

        // very short delay in order for us get the correct active slides
        setTimeout(() => {
            const sliderChildren = slider[0].children[0].children[0].children;
            // loop through each active slide for our current slider
            $(sliderChildren).each((index, item) => {
                // add current active slide height to our active slides array
                activeSlides.push([$(item)[0].scrollHeight]);
            });

            // for each of the active slides heights
            activeSlides.forEach((item) => {
                // if current active slide height is greater than tallest slide height
                if (item > tallestSlide) {
                    // override tallest slide height to current active slide height
                    tallestSlide = item;
                }
            });

            // set the current slider slick list height to current active tallest slide height
            _this._elements.$tile.height(tallestSlide);
        }, 500);
    }
}

moduleRegistry.registerModule('CardTiles', CardTiles);
moduleRegistry.autoApplyModule('CardTiles', config.selectors.root);
